// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyBb_QYYC3GRC5PpYGbkj94ppgGPtLasyHw",
    authDomain: "niftic-styles.firebaseapp.com",
    databaseURL: "https://niftic-styles.firebaseio.com",
    projectId: "niftic-styles",
    storageBucket: "niftic-styles.appspot.com",
    messagingSenderId: "723873903341",
    appId: "1:723873903341:web:8d23f54dbc197182b252e4"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
